module.exports = __webpack_public_path__ + "static/media/close-arrow.23ce6cc7.svg";